import SponsoredJobEditor from './SponsoredJobEditor';
export default SponsoredJobEditor;
